import Pie from './Pie'
import Bar from './Bar'

export default {
    Pie,
    Bar
}